export const UrgencyBadge = ({ offer }) => {
  const tier = offer?.urgency_tier;
  const expiresIn = offer?.deal_expires_in;
  const isYearRound = offer?.seasonal_label === "Year-round" || offer?.seasonal_availability === "year_round" || (!offer?.seasonal_availability && !offer?.seasonal_label);

  const claimLabel = (days) => isYearRound ? "claim window" : (days === 1 ? "day left" : "days left");

  const config = {
    critical: { bg: "bg-red-600 animate-pulse", label: expiresIn <= 1 ? "Last day to claim!" : "Claim window closing!" },
    urgent:   { bg: "bg-red-500", num: expiresIn, unit: claimLabel(expiresIn) },
    high:     { bg: "bg-orange-500", num: expiresIn, unit: claimLabel(expiresIn) },
    medium:   { bg: "bg-amber-500", num: expiresIn, unit: claimLabel(expiresIn) },
    low:      { bg: "bg-green-500", label: "Year-round" },
    expired:  { bg: "bg-slate-400", label: "Window closed" },
  };

  const c = config[tier] || config.low;

  if (c.num != null) {
    return (
      <span className={`inline-flex flex-col items-center justify-center px-2.5 py-1 rounded-lg text-white ${c.bg} leading-tight`} data-testid="urgency-badge">
        <span className="text-sm font-black">{c.num}</span>
        <span className="text-[8px] font-semibold uppercase tracking-wide">{c.unit}</span>
      </span>
    );
  }

  return <span className={`px-2.5 py-1 rounded-lg text-[10px] font-bold text-white ${c.bg}`} data-testid="urgency-badge">{c.label}</span>;
};
